import { usePositionStore } from '@/feature/terminal_tables/position/PositionStore';
import { useOpenOrdersStore } from '../../features/trading/OpenOrdersStore';
import useAppStore from '../rootStore';

const pendingMarketIds = new Set<number>();
const DEBOUNCE_MS = 150;
let debounceHandle: ReturnType<typeof setTimeout> | null = null;

const shouldRunPositionRecalc = (): boolean => {
  const appStore = useAppStore.getState();
  if (!appStore.isAtLeastAuthenticated()) return false;
  if (usePositionStore.getState().rawPositions.size === 0) return false;
  return true;
};

export function schedulePositionRecalcForMarkets(marketIds: number[]): void {
  if (!marketIds?.length) return;

  marketIds.forEach((marketId) => pendingMarketIds.add(marketId));

  if (debounceHandle) {
    clearTimeout(debounceHandle);
  }

  debounceHandle = setTimeout(() => {
    if (!shouldRunPositionRecalc() || pendingMarketIds.size === 0) {
      debounceHandle = null;
      return;
    }

    const ids = Array.from(pendingMarketIds);
    pendingMarketIds.clear();
    debounceHandle = null;

    const markets = useAppStore.getState().markets;
    const orders = Array.from(useOpenOrdersStore.getState().orders.values());
    usePositionStore.getState().recalculateFromCurrentPrices({
      markets,
      orders,
      marketIds: ids,
      reason: 'market-update',
    });
  }, DEBOUNCE_MS);
}
